export const PROJECT_NAME = 'iMe Lab';
export const PROJECT_SHORT_NAME = 'iMe';

export const EMAIL_SUPPORT = 'support@imem.app';
export const EMAIL_INFO = 'info@imem.app';
